import { IApiRequest } from "@miplatform/types";
import { SUBSCRIPTION_SERVICE } from "../../../constants";
import { apiOptions, apiRequest } from "../../../utils";

const API_ROLE_RECORD_PERMISSION = `${SUBSCRIPTION_SERVICE}/roles`;

export const roleRecordPermissions = {
  getAll: async ({ filters, sort, top, skip, id }: IApiRequest = {}) => {
    const options = await apiOptions({
      url: `${API_ROLE_RECORD_PERMISSION}/${id}/record-permissions`,
      method: "get",
      filters,
      sort,
      top,
      skip,
    });
    return apiRequest(options);
  },
};
